export const UNIT_IMAGES = {
  pickup:
    "https://public.readdy.ai/ai/img_res/49af2330-c0bc-46e2-8446-053c2903911c.png",
  truck:
    "https://public.readdy.ai/ai/img_res/90f212a7-9dc8-444e-819d-508aaa5bba3b.png",
  motorcycle:
    "https://public.readdy.ai/ai/img_res/427278b4-e6ce-42c5-93e8-0b8221b00079.png",
  suv: "https://public.readdy.ai/ai/img_res/ddef5853-22a9-41e3-ace3-bc0855c12077.png",
  van: "https://public.readdy.ai/ai/img_res/81f69c74-d8e5-47c1-8392-af2d455702cc.png",
} as const;

export type UnitImageKey = keyof typeof UNIT_IMAGES;

const MODEL_KEYWORDS = [
  ["motorcycle", ["moto", "motocicleta", "motorcycle", "bike"]],
  ["pickup", ["pickup", "pick-up", "camioneta", "ranger", "hilux", "frontier"]],
  ["van", ["van", "sprinter", "transit", "urvan", "combi"]],
  ["suv", ["suv", "jeep", "explorer", "tahoe", "durango"]],
  ["truck", ["truck", "camion", "camión", "tracto", "torton", "remolque", "trailer"]],
] as const satisfies readonly (readonly [UnitImageKey, readonly string[]])[];

export function resolveUnitImage(
  type: string | undefined,
  model: string | undefined,
  brand: string | undefined,
): string {
  const haystack = `${type ?? ""} ${model ?? ""} ${brand ?? ""}`.toLowerCase();
  const match = MODEL_KEYWORDS.find(([, keywords]) =>
    keywords.some((keyword) => haystack.includes(keyword)),
  );
  return UNIT_IMAGES[match?.[0] ?? "truck"];
}
